import { system } from '../theme';

import { luxurySystem } from './luxury';

import type { SystemContext } from '@chakra-ui/react';

export const THEME_NAMES = ['default', 'luxury'] as const;

export type ThemeName = (typeof THEME_NAMES)[number];

export const themes: Record<ThemeName, SystemContext> = {
  default: system,
  luxury: luxurySystem,
};

export function getTheme(name: ThemeName): SystemContext {
  return themes[name];
}

export function isThemeName(value: unknown): value is ThemeName {
  return typeof value === 'string' && THEME_NAMES.includes(value as ThemeName);
}
